import { useAtomValue } from 'jotai'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { HStack } from '~/components/elements/HStack'
import { IconButton } from '~/components/elements/IconButton'
import { LabelingContainer } from '~/components/elements/LabelingContainer'
import { type StyledButtonProps } from '~/components/elements/StyledButton'
import { StyledInput } from '~/components/elements/StyledInput'
import { VStack } from '~/components/elements/VStack'
import { useFormField } from '~/hooks/useFormField'
import { ensureExists } from '~/utils'

import { dialogInfoAtom } from '../../atoms'

import { AttachedBrandSelector } from './AttachedBrandSelector'
import styles from './BrandInput.css'
import { type InputValues } from './utils'

export type BrandInputProps = {
  index: number
  onDelete: (index: number) => void
}

export const BrandInput = ({ index, onDelete }: BrandInputProps) => {
  const { t } = useTranslation()
  const dialogInfo = useAtomValue(dialogInfoAtom)
  const surveyGroup = ensureExists(
    dialogInfo?.surveyGroup,
    t('assertion_failed'),
  )
  const { control } = useFormContext<InputValues>()
  const nameField = useFormField(control, `brands.${index}.name`)

  const handleDeleteButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    onDelete(index)
  }, [index, onDelete])

  return (
    <HStack className={styles.root} padding={2} spacing={4}>
      <HStack className={styles.left} spacing={0}>
        <IconButton
          buttonStyle="light"
          fillMode="flat"
          icon="delete"
          onClick={handleDeleteButtonClick}
        />

        <LabelingContainer label={t('brand_name_8')}>
          <StyledInput {...nameField} />
        </LabelingContainer>
      </HStack>

      <VStack className={styles.right} spacing={4}>
        {surveyGroup.surveys.map((survey) => (
          <AttachedBrandSelector
            key={survey.id}
            index={index}
            survey={survey}
          />
        ))}
      </VStack>
    </HStack>
  )
}
